import { NgModule } from "@angular/core";
import { Routes, RouterModule } from '@angular/router';
import { BarComponent } from "./bar/bar.component";
import { InStatisticsComponent } from "./in-statistics/in-statistics.component";
import { MessageCountComponent } from "./message-count/message-count.component";
import {RepitiveCountComponent} from "./repitive-count/repitive-count.component"
import {VlridUnblockCountComponent} from "./vlrid-unblock-count/vlrid-unblock-count.component"
import { MessageDeliveryStatisticsComponent } from "./message-delivery-statistics/message-delivery-statistics.component";
import { PricePointHistoryComponent } from "./price-point-history/price-point-history.component";
import { RoamersCountHistoryComponent } from "./roamers-count-history/roamers-count-history.component";
import { RoamersPackHistoryComponent } from "./roamers-pack-history/roamers-pack-history.component";
import { RoamersSegmentComponent } from "./roamers-segment/roamers-segment.component";
import { RoamfreeInErrorCodeComponent } from "./roamfree-in-error-code/roamfree-in-error-code.component";
import { RrmsDayWiseReportsComponent } from "./rrms-day-wise-reports/rrms-day-wise-reports.component";
import {RrmsActiveDeactiveMsissdnComponent} from "./rrms-active-deactive-msisdn/rrms-active-deactive-msisdn.component";

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'roamers-segment',
        component: RoamersSegmentComponent
      }
    ]
  }, {
    path: '',
    children: [
      {
        path: 'roamers-count-history',
        component: RoamersCountHistoryComponent
      }
    ]
  }, {
    path: '',
    children: [
      {
        path: 'price-point-history',
        component: PricePointHistoryComponent
      }
    ]
  },{
        path: '',
        children: [
          {
            path: 'roamers-pack-history',
            component: RoamersPackHistoryComponent
          }
    ]
  }, {
    path: '',
    children: [
      {
        path: 'roamfree-in-error-code',
        component: RoamfreeInErrorCodeComponent
      }
    ]
  }, {
    path: '',
    children: [
      {
        path: 'in-statistics',
        component: InStatisticsComponent
      }
    ]
  },  {
    path: '',
    children: [
      {
        path: 'message-count',
        component: MessageCountComponent
      }
    ]
  },{
    path: '',
    children: [
      {
        path: 'repitive-count',
        component: RepitiveCountComponent
      }
    ]
  },{
    path: '',
    children: [
      {
        path: 'vlrid-unblock-count',
        component: VlridUnblockCountComponent
      }
    ]
  },{
    path: '',
    children: [
      {
        path: 'rrms-active-deactive-msisdn',
        component: RrmsActiveDeactiveMsissdnComponent
      }
    ]
  },  {
    path: '',
    children: [
      {
        path: 'rrms-day-wise-reports',
        component: RrmsDayWiseReportsComponent
      }
    ]
  },
  {
    path: '',
    children: [
      {
        path: 'message-delivery-statistics',
        component: MessageDeliveryStatisticsComponent
      }
    ]
  }
   
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RoamersRoutingModule { }